import { useMutation } from 'react-query';

import {
  armCompleteVirtualAlarmCentralById,
  armPartialVirtualAlarmCentralById,
  createDeviceToVirtualAlarmCentral,
  createPartition,
  createVirtualAlarmCentral,
  deletePartition,
  deletePartitionUserOfVirtualAlarmCentralId,
  deleteVirtualAlarmCentralById,
  deleteVirtualAlarmCentralDevice,
  disarmCompleteVirtualAlarmCentralById,
  disarmPartialVirtualAlarmCentralById,
  getAlllDevicesByPartitionId,
  getAllPartitionsByAlarmCentralId,
  getAllVirtualAlarmCentralDevices,
  getAllVirtualAlarmCentralEvents,
  getDeviceVirtualAlarmCentralById,
  getPartitionsFromLoggedUserAsync,
  getPartitionsUsersOfVirtualAlarmCentralId,
  getVirtualAlarmCentralById,
  updateDeviceToVirtualAlarmCentral,
  updatePartitions,
  updatePartitionsUsersOfVirtualAlarmCentralId,
  updateUpdateVirtualAlarmCentral,
} from '../..';

export const useCreateVirtualAlarmCentral = () =>
  useMutation(createVirtualAlarmCentral);

export const useGetVirtualAlarmCentralById = () =>
  useMutation(getVirtualAlarmCentralById);

export const useUpdateVirtualAlarmCentral = () =>
  useMutation(updateUpdateVirtualAlarmCentral);

export const useDeleteVirtualAlarmCentral = () =>
  useMutation(deleteVirtualAlarmCentralById);

export const useGetAllPartitionsByVirtualAlarmCentralId = () =>
  useMutation(getAllPartitionsByAlarmCentralId);

export const useUpdatePartitionsByVirtualAlarmCentralId = () =>
  useMutation(updatePartitions);

export const useCreatePartition = () => useMutation(createPartition);

export const useGetAllVirtualAlarmCentralEvents = () =>
  useMutation(getAllVirtualAlarmCentralEvents);

export const useArmCompleteVirtualAlarmCentral = () =>
  useMutation(armCompleteVirtualAlarmCentralById);

export const useDisarmCompleteVirtualAlarmCentral = () =>
  useMutation(disarmCompleteVirtualAlarmCentralById);

export const useArmPartialVirtualAlarmCentral = () =>
  useMutation(armPartialVirtualAlarmCentralById);

export const useDisarmPartialVirtualAlarmCentral = () =>
  useMutation(disarmPartialVirtualAlarmCentralById);

export const useCreateDeviceToVirtualAlarmCentral = () =>
  useMutation(createDeviceToVirtualAlarmCentral);

export const useUpdateDeviceToVirtualAlarmCentral = () =>
  useMutation(updateDeviceToVirtualAlarmCentral);

export const useGetDeviceVirtualAlarmCentralById = () =>
  useMutation(getDeviceVirtualAlarmCentralById);

export const useDeleteVirtualAlarmCentralDeviceById = () =>
  useMutation(deleteVirtualAlarmCentralDevice);

export const useGetAllVirtualAlarmCentralDevices = () =>
  useMutation(getAllVirtualAlarmCentralDevices);

export const useGetAlllDevicesByPartitionId = () =>
  useMutation(getAlllDevicesByPartitionId);

export const useGetPartitionsUsersOfVirtualAlarmCentralId = () =>
  useMutation(getPartitionsUsersOfVirtualAlarmCentralId);

export const useGetPartitionsFromLoggedUserAsync = () =>
  useMutation(getPartitionsFromLoggedUserAsync);

export const useDeletePartitionUserOfVirtualAlarmCentralId = () =>
  useMutation(deletePartitionUserOfVirtualAlarmCentralId);

export const useDeletePartition = () => useMutation(deletePartition);

export const useUpdatePartitionsUsersOfVirtualAlarmCentralId = () =>
  useMutation(updatePartitionsUsersOfVirtualAlarmCentralId);
